module.exports = "/static/media/no-items.b14cb76a.png";